import { Handshake, Scale, MessageSquare } from "lucide-react";

const PRINCIPLES = [
    {
        icon: Handshake,
        title: "Long-term partnerships",
        desc: "We build supplier and brand relationships that last — not one-off transactions."
    },
    {
        icon: Scale,
        title: "Compliance first",
        desc: "Authorized sourcing, clean paperwork, and full documentation on every transaction."
    },
    {
        icon: MessageSquare,
        title: "Transparent communication",
        desc: "Direct, founder-led communication with clear timelines, terms and expectations."
    }
];

const CREDIBILITY = [
    "Wyoming-Registered LLC",
    "EIN Registered",
    "Founded 2026",
    "B2B Only — No Retail"
];

export default function TrustedBy() {
    return (
        <section
            aria-label="Our principles and credibility"
            className="bg-background border-b border-border"
        >
            <div className="container-px mx-auto max-w-7xl py-14 lg:py-20">
                <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-14">
                    <p className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-medium">
                        How we operate
                    </p>
                    <h2 className="mt-3 text-2xl lg:text-3xl font-semibold text-foreground tracking-tight">
                        Built on three principles
                    </h2>
                    <p className="mt-3 text-sm lg:text-base text-muted-foreground leading-relaxed">
                        A new B2B wholesale and Amazon sourcing company should earn trust through how it works — not exaggerated metrics. Here is what we commit to with every partner.
                    </p>
                </div>

                <ul className="grid sm:grid-cols-3 gap-5 lg:gap-6">
                    {PRINCIPLES.map((p) => (
                        <li
                            key={p.title}
                            className="flex flex-col p-6 lg:p-7 rounded-xl bg-background border border-border hover:border-primary/30 hover:shadow-soft transition-smooth"
                        >
                            <span className="grid place-items-center w-11 h-11 rounded-lg bg-accent text-accent-foreground border border-border">
                                <p.icon className="w-5 h-5" />
                            </span>
                            <h3 className="mt-5 font-display text-lg font-semibold text-foreground leading-snug">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                {p.desc}
                            </p>
                        </li>
                    ))}
                </ul>

                <div className="mt-12 lg:mt-14 flex flex-wrap items-center justify-center gap-x-3 gap-y-3">
                    {CREDIBILITY.map((c) => (
                        <span
                            key={c}
                            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-border bg-muted/40 text-xs lg:text-sm font-medium text-foreground/80"
                        >
                            <span className="w-1.5 h-1.5 rounded-full bg-primary/70" />
                            {c}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
